import { render, staticRenderFns } from "./PwaInstall.vue?vue&type=template&id=6d9e0dda"
import script from "./PwaInstall.vue?vue&type=script&lang=js"
export * from "./PwaInstall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports